export enum UnauthenticatedRoutes {
  LOGIN_ROUTE = '/',
  WORKSPACE_SELECTION_ROUTE = '/workspaces',
  WORKSPACE_HELP_ROUTE = '/workspaces/help',
}
